import { useCallback, useEffect, useState } from "react";
import { api, type CatalogGame } from "../api";

export function GameCatalog({ onPlay }: { onPlay: (path: string) => void }) {
  const [games, setGames] = useState<CatalogGame[]>([]);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    try {
      setGames((await api<{ games: CatalogGame[] }>("/api/games")).games);
      setError("");
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : "Не удалось загрузить каталог");
    }
  }, []);

  useEffect(() => {
    void refresh();
    const timer = window.setInterval(() => void refresh(), 5_000);
    return () => window.clearInterval(timer);
  }, [refresh]);

  return <section className="catalog" aria-labelledby="games-title">
    <div className="section-heading compact-heading">
      <div><p className="eyebrow">КАТАЛОГ</p><h1 id="games-title">Во что играем?</h1></div>
      <button className="icon-button" onClick={() => void refresh()} aria-label="Обновить каталог">↻</button>
    </div>
    {error && <p className="error" role="alert">{error}</p>}
    <div className="game-grid">
      {games.length === 0 && !error && [0, 1, 2].map((item) => <div className="game-card skeleton" key={item} />)}
      {games.map((game) => <article className={`game-card ${game.status}`} key={game.id}>
        <div className="game-cover"><img src={game.cover} alt="" /></div>
        <div className="game-copy">
          <div className="game-kicker"><span>{game.status === "available" ? "ДОСТУПНО" : "СКОРО"}</span>{game.status === "available" && <small>{game.playMode === "solo" ? "Для одного" : `до ${game.maxPlayers} игроков`}</small>}</div>
          <h2>{game.name}</h2>
          <p>{game.description}</p>
          {game.status === "available" ? <div className="game-card-footer">
            <div className="live-stats">{game.playMode === "solo" ? <span>Кампания · 15 уровней</span> : <><span><i />{game.rooms} {game.rooms === 1 ? "комната" : "комнат"}</span><span>{game.players} в игре</span></>}</div>
            <button className="primary" onClick={() => onPlay(game.path)}>ИГРАТЬ</button>
          </div> : <div className="game-card-footer"><span className="soon-note">Концепт · без даты</span><button className="secondary" disabled>СКОРО</button></div>}
        </div>
      </article>)}
    </div>
  </section>;
}
